import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
// Feature pages
import { ClientsPage } from './features/clients/ClientsPage';
import { HealthPage } from './features/health/HealthPage';
import { MetricsPage } from './features/metrics/MetricsPage';
import { ProfilePage } from './features/profile/ProfilePage';
import { UsersPage } from './features/users/UsersPage';
import { DashboardLayout } from './layouts/DashboardLayout';
import { ActivationPage } from './pages/ActivationPage';
import { DashboardHome } from './pages/DashboardHome';
import { SignInPage } from './pages/SignInPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';

// Initialize AWS Amplify configuration
import './config/aws-config';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/activate" element={<ActivationPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />

          {/* Protected dashboard routes with shared layout */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard home */}
            <Route index element={<DashboardHome />} />

            {/* Admin-only routes */}
            <Route
              path="users"
              element={
                <ProtectedRoute requiredRoles={['admin']}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute requiredRoles={['admin']}>
                  <div className="p-8">Settings page placeholder</div>
                </ProtectedRoute>
              }
            />

            {/* Coach + Admin routes */}
            <Route
              path="clients"
              element={
                <ProtectedRoute requiredRoles={['coach']}>
                  <ClientsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="assessments"
              element={
                <ProtectedRoute requiredRoles={['coach', 'admin']}>
                  <div className="p-8">Assessments page placeholder</div>
                </ProtectedRoute>
              }
            />

            {/* User routes (accessible to all) */}
            <Route path="health" element={<HealthPage />} />
            <Route path="metrics" element={<MetricsPage />} />
            <Route
              path="coach"
              element={
                <ProtectedRoute requiredRoles={['user']}>
                  <div className="p-8">My Coach page placeholder</div>
                </ProtectedRoute>
              }
            />

            {/* Shared routes */}
            <Route path="profile" element={<ProfilePage />} />
          </Route>

          {/* Default route - redirect to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* 404 - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
